module.exports = __webpack_public_path__ + "static/img/logo5.0e7e902d.jpg";